import { exec, query } from './client'

export const SCHEMA_VERSION = 3

const CREATE_META = `
  CREATE TABLE IF NOT EXISTS meta (
    key   TEXT PRIMARY KEY,
    value TEXT NOT NULL
  )
`

const CREATE_INSTRUMENTS = `
  CREATE TABLE IF NOT EXISTS instruments (
    symbol                  TEXT PRIMARY KEY,
    type                    TEXT NOT NULL,
    trading                 TEXT,
    fractional_trading      TEXT,
    option_trading          TEXT,
    option_spread_trading   TEXT,
    shorting_availability   TEXT,
    raw                     TEXT NOT NULL
  )
`

const INDEXES = [
  'CREATE INDEX IF NOT EXISTS idx_instruments_type_symbol ON instruments(type, symbol)',
]

async function readSchemaVersion(): Promise<number | null> {
  try {
    const rows = await query<{ value: string }>(
      "SELECT value FROM meta WHERE key = 'schema_version'",
    )
    if (rows.length === 0) return null
    const parsed = parseInt(rows[0].value, 10)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

async function createSchema(): Promise<void> {
  await exec(CREATE_META)
  await exec(CREATE_INSTRUMENTS)
  for (const idx of INDEXES) await exec(idx)
  await exec(
    "INSERT OR REPLACE INTO meta (key, value) VALUES ('schema_version', ?)",
    [String(SCHEMA_VERSION)],
  )
}

async function dropEverything(): Promise<void> {
  await exec('DROP TABLE IF EXISTS transactions')
  await exec('DROP TABLE IF EXISTS instruments')
  await exec('DROP TABLE IF EXISTS meta')
}

export async function bootstrapSchema(): Promise<void> {
  const current = await readSchemaVersion()
  if (current === SCHEMA_VERSION) return
  if (current !== null && current !== SCHEMA_VERSION) {
    await dropEverything()
  }
  await createSchema()
}

export async function getMeta(key: string): Promise<string | null> {
  const rows = await query<{ value: string }>(
    'SELECT value FROM meta WHERE key = ?',
    [key],
  )
  return rows.length ? rows[0].value : null
}

export async function setMeta(key: string, value: string): Promise<void> {
  await exec(
    'INSERT OR REPLACE INTO meta (key, value) VALUES (?, ?)',
    [key, value],
  )
}
